module.exports = __webpack_public_path__ + "static/media/generic.e1934a5d.jpg";